export default {
	name: 'net-shceduling-password-dialog',
	mixins: [],
	extends: {},
	components: {},
	props: [ 'password' ],
	data() {
		return {
			inputPassword: this.password,
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async emitPassword() {

			// 使用者輸入驗證
			const isValid = await this.$validator.validate();	
			if(!isValid){
				return;
			}

			// emit data to parent
			let temp = this.inputPassword;
			this.inputPassword = '';
			this.$emit('password', temp);
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/addSetting/netScheduling/netSchedulingPasswordDialog.js